import React from "react";
import { TESTIMONIALS } from "../mock";
import { Reveal } from "../hooks/useReveal";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">Loved by early users</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            Riders &amp; drivers agree
          </h2>
        </Reveal>

        {/* feature quote */}
        <Reveal delay={80}>
          <div className="mt-14 relative rounded-3xl border border-[#2fd645]/25 bg-gradient-to-br from-[#0f1613] to-[#0b0f0d] p-8 sm:p-12 overflow-hidden">
            <Quote className="absolute -top-2 right-6 h-28 w-28 text-[#2fd645]/10" fill="currentColor" />
            <div className="relative flex flex-col sm:flex-row items-start gap-6">
              <div className="h-16 w-16 shrink-0 rounded-full bg-[#2fd645]/15 border border-[#2fd645]/40 flex items-center justify-center font-display font-extrabold text-2xl text-[#2fd645]">
                C
              </div>
              <div>
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={`feat-star-${i}`} className="h-5 w-5 text-[#2fd645]" fill="#2fd645" />
                  ))}
                </div>
                <p className="text-xl sm:text-2xl text-white leading-relaxed font-medium">
                  “InstantDrive changed how I move around Lagos. I saw the price
                  before I booked, my driver arrived in minutes, and paying was
                  completely cashless. This is how ride-hailing should feel.”
                </p>
                <div className="mt-5 text-white/70">
                  <span className="font-semibold text-white">Chidinma O.</span> · Early rider, Lagos
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.slice(1).map((t, i) => (
            <Reveal key={t.name} delay={i * 100}>
              <div className="h-full rounded-3xl border border-white/10 bg-[#0e1311] p-7 transition-all duration-300 hover:border-[#2fd645]/30">
                <div className="flex gap-1 mb-4">
                  {[...Array(t.rating)].map((_, k) => (
                    <Star key={`${t.name}-star-${k}`} className="h-4 w-4 text-[#2fd645]" fill="#2fd645" />
                  ))}
                </div>
                <p className="text-white/80 leading-relaxed">“{t.text}”</p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-[#2fd645]/12 border border-[#2fd645]/25 flex items-center justify-center font-bold text-[#2fd645]">
                    {t.name[0]}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-white">{t.name}</div>
                    <div className="text-xs text-white/50">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
